import React, {useRef} from 'react';
import dynamic from 'next/dynamic';
import {Box, type BoxProps} from '@tempo/core';
import {useIsInViewport} from '@app/hooks/use-is-in-viewport';

const Lottie = dynamic(
	() =>
		import('@lottiefiles/dotlottie-react').then((mod) => mod.DotLottieReact),
	{
		loading: () => <div style={{height: '400px'}}></div>,
		ssr: false,
	},
);

export default function DzrLottie({
	autoplay = true,
	loop = true,
	src,
	...props
}: BoxProps & {src: string; loop?: boolean; autoplay?: boolean}) {
	const ref = useRef<HTMLDivElement>(null);
	const isInView = useIsInViewport(ref);
	if (!isInView) {
		return <Box {...props} ref={ref} />;
	}
	return (
		<Box {...props} ref={ref}>
			<Lottie src={src} loop={loop} autoplay={autoplay} />
		</Box>
	);
}
